module.exports = __webpack_public_path__ + "static/media/bang.378692bf.svg";